export const FREE_ACCESS_REMINDER_WINDOW_DAYS = 14
export const FREE_ACCESS_URGENT_DAYS = 7
export const normalizeFreeAccess = (raw = {}) => {
  const value = raw || {}
  return {
    state: ['none', 'active', 'ended'].includes(value.state) ? value.state : 'none',
    startedAt: value.startedAt || null,
    endsAt: value.endsAt || null,
    daysLeft: Number.isFinite(value.daysLeft) ? value.daysLeft : null,
    source: value.source || null,
    endedReason: value.endedReason || null,
    eligible: value.eligible === true,
    claimable: value.claimable === true,
    superseded: value.superseded === true,
    readinessKnown: value.readinessKnown !== false && typeof value.claimable === 'boolean',
  }
}
export const freeAccessOf = account => normalizeFreeAccess((account && (account.freeAccess
  || (account.subscription && account.subscription.freeAccess))) || {})
export const isFreeAccessActive = fa => Boolean(fa && fa.state === 'active' && !fa.superseded && !fa.endedReason)
export const freeAccessDaysLeft = fa => (fa && Number.isFinite(fa.daysLeft) ? fa.daysLeft : null)

// First argument is the newest snapshot. Partial /user/my fields never erase
// readiness established by the status endpoint.
export const mergeFreeAccess = (...sources) => {
  const existing = sources.filter(Boolean)
  const latest = existing[0] || {}
  const ready = existing.find(value => typeof value.claimable === 'boolean' && value.readinessKnown !== false)
  return normalizeFreeAccess({
    ...latest,
    ...(ready ? {
      eligible: ready.eligible, claimable: ready.claimable, readinessKnown: true,
    } : { readinessKnown: false }),
  })
}
export const freeAccessCelebrationKey = (userId, startedAt) => `free-access-celebrated:${userId}:${startedAt}`
const seenCelebrations = new Set()
export const hasSeenFreeAccessCelebration = key => {
  if (seenCelebrations.has(key)) return true
  try { return localStorage.getItem(key) === '1' } catch (_) { return true }
}
export const markFreeAccessCelebrationSeen = key => {
  seenCelebrations.add(key)
  try { localStorage.setItem(key, '1') } catch (_) { /* Storage may be disabled. */ }
}
export const freeAccessReminderDismissKey = (userId, dayIso) => `free-access-reminder-dismissed:${userId}:${dayIso}`
